import React from "react";

import { ResponseType, OptionsType } from "commons/types/http";

import useHttpManaged from "hooks/useHttpManaged";

import { PathParamsWithId } from "commons/types/api/common";

import { SectionHighlightBody, SectionHighlightDetails } from "types/api/blocks/sectionHighlight";

function useSectionHighlightApi() {
    const { get, del, post } = useHttpManaged();
    const getOneSectionHighlight = React.useCallback((pathParams: PathParamsWithId, options?: OptionsType, headers?: { [x: string]: string }): ResponseType<SectionHighlightDetails> => {
        return get<PathParamsWithId, undefined, SectionHighlightDetails>({
            url: "/blocks/section-highlight/:id",
            pathParams: pathParams,
            options: options,
            headers: headers
        });
    }, [get]);
    const saveSectionHighlight = React.useCallback((body: SectionHighlightBody, options?: OptionsType, headers?: { [x: string]: string }): ResponseType<null> => {
        return post<undefined, undefined, SectionHighlightBody, null>({
            url: "/blocks/section-highlight",
            body: body,
            options: options,
            headers: headers
        });
    }, [post]);
    const deleteSectionHighlight = React.useCallback((pathParams: PathParamsWithId, options?: OptionsType, headers?: { [x: string]: string }): ResponseType<null> => {
        return del<PathParamsWithId, undefined, null>({
            url: "/blocks/section-highlight/:id",
            pathParams: pathParams,
            options: options,
            headers: headers
        });
    }, [del]);
    return {
        getOneSectionHighlight,
        saveSectionHighlight,
        deleteSectionHighlight
    };
}

export default useSectionHighlightApi;